/* eslint-disable */
import React, { useState, useEffect } from 'react';

// @material-ui/core components
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Check from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import ItemPicUpload from 'components/CustomUpload/ItemPicUpload';

const Items = (props) => {
  const {
    items,
    step,
    steps,
    itemCount,
    errorMessage,
    classes,
    changeStep,
    addItem,
    removeItem,
    removePicture,
    handleItemChange,
    handleItemSelectChange,
    handleToggleItemServices,
    onAssignPic,
    toggleFootage,
  } = props;
  const [picToDel, setPicToDel] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0);

  const createItem = (i) => {
    const packagingTypes = [
      '',
      'Pallet(s)',
      'Piece(s)',
      'Box(es)',
      'Crate(s)',
      'Drum(s) or Barrel(s)',
    ];
    const freightClass = [
      '',
      'I dont know',
      '50',
      '55',
      '60',
      '65',
      '70',
      '77.5',
      '85',
      '92.5',
      '100',
      '110',
      '125',
      '150',
      '175',
      '200',
      '250',
      '300',
      '400',
      '500',
    ];

    const item = (
      <div>
        <h3 className={classes.bodyText}>
          ITEM #{i + 1}
          <ItemPicUpload
            iter={i}
            onAssignPic={onAssignPic}
            files={{ ...items[i].files }}
            del={picToDel}
          />
        </h3>
        {items[i].files &&
          items[i].files.map((pic, index) => {
            return (
              <div className="picture">
                <img
                  src={items[i].files[index].picURL}
                  style={{ width: '120px' }}
                  className="picture-src"
                  alt="..."
                />

                <IconButton
                  style={{ color: 'red' }}
                  onClick={() => {
                    setPicToDel(items[i].files[index].picURL);
                    removePicture(i, index);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            );
          })}
        <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
        <div
          className={
            classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal
          }
        >
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={-1}
                onClick={() => toggleFootage(i)}
                checked={Boolean(items[i].isFootage)}
                checkedIcon={
                  <Check
                    className={classes.checkedIcon}
                    style={{ color: 'limegreen' }}
                  />
                }
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />
            }
            classes={{ label: classes.bodyText }}
            label="Footage"
          />
          <br />
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={-1}
                onClick={() => handleToggleItemServices('Hazmat', i)}
                checked={'isHazmat' in items[i] ? true : false}
                checkedIcon={
                  <Check 
                    className={classes.checkedIcon}
                    style={{ color: 'limegreen' }}
                  />
                }
                icon={<Check className={classes.uncheckedIcon} />}
                color="primary"
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />
            }
            classes={{ label: classes.bodyText }}
            label={`Hazmat`}
          />
        </div>

        <br />

        {'isHazmat' in items[i] ? (
          <GridContainer>
            <GridItem xs={4}>
              <CustomInput
                labelText="UN Number"
                id="unNumber"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  required: true,
                  type: 'text',
                  value: items[i]['unNumber'],
                  onChange: (event) => handleItemChange(event, i),
                  defaultValue: items[i].unNumber ? items[i].unNumber : '',
                }}
              />
            </GridItem>
            <GridItem xs={4}>
              <CustomInput
                labelText="Proper Shipping Name"
                id="properShippingName"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  required: true,
                  type: 'text',
                  value: items[i]['properShippingName'],
                  onChange: (event) => handleItemChange(event, i),
                  defaultValue: items[i].properShippingName
                    ? items[i].properShippingName
                    : '',
                }}
              />
            </GridItem>
            <GridItem xs={4}>
              <CustomInput
                labelText="Emergency Response Number"
                id="emergencyResponseNumber"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  required: true,
                  type: 'text',
                  value: items[i]['emergencyResponseNumber'],
                  onChange: (event) => handleItemChange(event, i),
                  defaultValue: items[i].emergencyResponseNumber
                    ? items[i].emergencyResponseNumber
                    : '',
                }}
              />
            </GridItem>
          </GridContainer>
        ) : null}

        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="packaging" className={classes.selectLabel}>
            PACKAGING:
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            classes={{
              select: classes.select,
            }}
            value={items[i]['packaging']}
            onChange={(event) => handleItemSelectChange(event, i)}
            inputProps={{
              id: 'packaging',
              name: 'packaging',
            }}
          >
            {packagingTypes.map((item) => (
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                }}
                value={item}
                key={item}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <GridContainer>
          <GridItem xs={6}>
            <CustomInput
              key={i}
              labelText="Qty"
              id="quantity"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                required: true,
                type: 'number',
                min: '0',
                step: '1',
                value: items[i]['quantity'],
                onChange: (event) => handleItemChange(event, i),
              }}
            />
          </GridItem>
          <GridItem xs={6}>
            <CustomInput
              labelText="Weight per Piece"
              id="weight"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                required: true,
                type: 'number',
                min: '0',
                step: '1',
                value: items[i]['weight'],
                onChange: (event) => handleItemChange(event, i),
              }}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={4}>
            <CustomInput
              labelText="Length"
              id="length"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                required: true,
                type: 'number',
                min: '0',
                step: '1',
                value: items[i]['length'],
                onChange: (event) => handleItemChange(event, i),
                defaultValue: items[i].length ? items[i].length : '',
              }}
            />
          </GridItem>
          {!items[i].isFootage ? (
            <React.Fragment>
              <GridItem xs={4}>
                <CustomInput
                  labelText="Width"
                  id="width"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    required: items[i].isFootage ? false : true,
                    type: 'number',
                    min: '0',
                    step: '1',
                    value: items[i]['width'],
                    onChange: (event) => handleItemChange(event, i),
                    defaultValue: items[i].width ? items[i].width : '',
                  }}
                />
              </GridItem>
              <GridItem xs={4}>
                <CustomInput
                  labelText="Height"
                  id="height"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    required: items[i].isFootage ? false : true,
                    type: 'number',
                    min: '0',
                    step: '1',
                    value: items[i]['height'],
                    onChange: (event) => handleItemChange(event, i),
                    defaultValue: items[i].height ? items[i].height : '',
                  }}
                />
              </GridItem>
            </React.Fragment>
          ) : null}
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <CustomInput
              labelText="Description"
              id="description"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                required: true,
                type: 'text',
                value: items[i]['description'],
                onChange: (event) => handleItemChange(event, i),
                defaultValue: items[i].description ? items[i].description : '',
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            <CustomInput
              labelText="Declared Value"
              id="declaredValue"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                required: true,
                type: 'number',
                value: items[i]['declaredValue'],
                onChange: (event) => handleItemChange(event, i),
                defaultValue: items[i].declaredValue
                  ? items[i].declaredValue
                  : '',
                startAdornment: <div style={{ margin: 'auto 8px' }}>$</div>,
              }}
            />
          </GridItem>
        </GridContainer>

        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="class" className={classes.selectLabel}>
            FREIGHT CLASS:
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            classes={{
              select: classes.select,
            }}
            value={items[i]['class']}
            onChange={(event) => handleItemSelectChange(event, i)}
            inputProps={{
              id: 'class',
              name: 'class',
            }}
          >
            {freightClass.map((item) => (
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                }}
                value={item}
                key={item}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div
          className={
            classes.checkboxAndRadio + ' ' + classes.checkboxAndRadioHorizontal
          }
        >
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={-1}
                onClick={() => handleToggleItemServices('Broken Down', i)}
                checked={'isBrokenDown' in items[i] ? true : false}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                color="primary"
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />
            }
            classes={{ label: classes.bodyText }}
            label="Item can be broken down"
          />
        </div>
      </div>
    );

    return item;
  };

  const displayItems = () => {
    const packagingTypes = [
      '',
      'Pallet(s)',
      'Box(es)',
      'Crate(s)',
      'Tote(s)',
      'Drum(s) or Barrel(s)',
    ];
    const freightClass = [
      '',
      'I dont know',
      '50',
      '55',
      '60',
      '65',
      '70',
      '77.5',
      '85',
      '92.5',
      '100',
      '110',
      '125',
      '150',
      '175',
      '200',
      '250',
      '300',
      '400',
      '500',
    ];
    var jsx = [];

    jsx.push(<p>Total Weight: {totalWeight}</p>);

    // console.log(itemCount)
    for (var i = 0; i < items.length; i++) {
      var item = createItem(i);
      jsx.push(item);
    }
    jsx.push(
      <Button color="primary" onClick={() => addItem()}>
        ADD ITEM
      </Button>
    );
    items.length > 1 &&
      jsx.push(
        <Button color="primary" onClick={() => removeItem()}>
          REMOVE ITEM
        </Button>
      );

    return jsx;
  };

  useEffect(() => {
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    if (weight !== totalWeight) setTotalWeight(weight);
  });

  return displayItems().map((item) => item);
};

export default Items;



// WEBPACK FOOTER //
// ./src/components/Forms/EditFreight.jsx